<template>
  <div class="nav" @click="onClickLeft">
    <van-icon name="arrow-left" />
  </div>
</template>

<script>
export default {
  name: "navbar",
  props: {},

  data() {
    return {};
  },
  components: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    // 返回上一页
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.replace({
          name: "index",
          query: {},
        });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.8;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
}
</style>
